module.exports = __webpack_public_path__ + "media/images/catalog-promo/promo1560-31e28f6736645cbb8c6d59be85acd6f1.jpg";